module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.multipage === true ? 'multi-page' : 'single-page'
  }, [_c('page-content', {
    attrs: {
      "breadcrumb": _vm.breadcrumb,
      "title": _vm.title,
      "logo": _vm.logo
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6e36d0e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/PageLayout.vue
// module id = 9lon
// module chunks = 273